<template>
    <!--begin::Card-->
    <div class="card">
        <!--begin::Card header-->
        <div class="card-header border-0">
            <!--begin::Card title-->
            <div class="card-title">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 28 28"
                    fill="none"
                    style="margin-right: 17px"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.5725 1.55556C15.5725 1.143 15.4069 0.747335 15.1119 0.455612C14.817 0.163888 14.4171 0 14 0C13.5829 0 13.183 0.163888 12.888 0.455612C12.5931 0.747335 12.4275 1.143 12.4275 1.55556V8.98022L7.96775 5.06022C7.81485 4.91654 7.6343 4.80476 7.43684 4.73151C7.23938 4.65826 7.02904 4.62505 6.81834 4.63385C6.60764 4.64266 6.40088 4.69329 6.21037 4.78275C6.01985 4.8722 5.84947 4.99865 5.70937 5.15457C5.56926 5.31049 5.46229 5.49269 5.39482 5.69034C5.32734 5.88798 5.30075 6.09703 5.31662 6.30505C5.33248 6.51307 5.39048 6.71581 5.48717 6.90121C5.58386 7.0866 5.71725 7.25086 5.87942 7.38422L12.9558 13.6064C13.2436 13.8592 13.6151 13.9989 14 13.9989C14.3849 13.9989 14.7564 13.8592 15.0442 13.6064L22.1206 7.38422C22.4164 7.10622 22.5914 6.72534 22.6087 6.32206C22.6259 5.91877 22.4839 5.52465 22.2128 5.22297C21.9418 4.92128 21.5627 4.73564 21.1558 4.70527C20.7489 4.67491 20.346 4.80218 20.0322 5.06022L15.5725 8.98022V1.55556ZM3.69517 17.1111C3.56367 19.7019 3.38017 22.2898 3.14478 24.8733V24.8796C3.14638 24.8834 3.14912 24.8866 3.15265 24.8889H24.8474L24.8505 24.8858L24.8552 24.8796V24.8749C24.6198 22.2908 24.4363 19.7024 24.3048 17.1111H21.9618C21.7044 17.111 21.451 17.1733 21.2237 17.2927C20.9964 17.412 20.8022 17.5847 20.6581 17.7956L19.3844 19.6638C18.9524 20.297 18.3699 20.8157 17.688 21.1742C17.0062 21.5328 16.2457 21.7203 15.4735 21.7202H12.5265C11.7543 21.7203 10.9938 21.5328 10.312 21.1742C9.63006 20.8157 9.04758 20.297 8.61564 19.6638L7.34188 17.7971C7.19796 17.5859 7.00383 17.413 6.77652 17.2933C6.54922 17.1737 6.29571 17.1112 6.03825 17.1111H3.69517ZM27.3666 14H21.9618C21.1895 14 20.4291 14.1874 19.7472 14.546C19.0653 14.9046 18.4828 15.4232 18.0509 16.0564L16.7771 17.9231C16.6332 18.1343 16.439 18.3073 16.2117 18.4269C15.9844 18.5465 15.7309 18.6091 15.4735 18.6091H12.5265C12.2692 18.6092 12.0158 18.5469 11.7885 18.4276C11.5612 18.3082 11.367 18.1356 11.2229 17.9247L9.94915 16.0564C9.5172 15.4232 8.93472 14.9046 8.25283 14.546C7.57094 14.1874 6.81049 14 6.03825 14H0.633443C0.633443 17.1609 0.243455 22.0189 0.0122918 24.6011C-0.0263032 25.0325 0.0262263 25.4672 0.166544 25.8775C0.306861 26.2877 0.5319 26.6647 0.827366 26.9843C1.12283 27.3039 1.48227 27.5593 1.88284 27.7341C2.28342 27.909 2.71638 27.9995 3.15422 28H24.8458C25.2836 27.9995 25.7166 27.909 26.1172 27.7341C26.5177 27.5593 26.8772 27.3039 27.1726 26.9843C27.4681 26.6647 27.6931 26.2877 27.8335 25.8775C27.9738 25.4672 28.0263 25.0325 27.9877 24.6011C27.7565 22.0189 27.3666 17.1609 27.3666 14Z"
                        fill="#006C90"
                    />
                </svg>
                Cargar Documentos
            </div>
            <!--begin::Card title-->
        </div>
        <!--end::Card header-->

        <!--begin: Card-body Drag and Drop-->
        <div class="card-body">
            <DropZone @drop="agregar" @change="agregar" />

            <div id="button-eliminar">
                <button @click="eliminarFilas" class="btn btn-melon">
                    Eliminar
                </button>
            </div>

            <div class="contenedor-table">
                <table class="table table-striped">
                    <thead class="thead-document">
                        <tr>
                            <th scope="col col-2" class="th-1">
                                <input
                                    type="checkbox"
                                    id="header-checkbox"
                                    v-model="selectAll"
                                />
                            </th>
                            <th scope="col" class="">Nombre archivo</th>
                            <th scope="col" class="">Fecha Carga</th>
                            <th scope="col" class="">Grupo</th>
                            <th scope="col" class="th-5"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="items.length == 0" class="text-center">
                            <th colspan="5">No hay archivos cargados</th>
                        </tr>

                        <tr v-for="(item, index) in items" :key="index">
                            <th class="text-center">
                                <input
                                    type="checkbox"
                                    :id="'checkbox' + index"
                                    v-model="item.selected"
                                />
                            </th>
                            <th scope="col">{{ item.nombreArchivo }}</th>
                            <th scope="col">{{ item.date }}</th>
                            <th scope="col">{{ item.group }}</th>
                            <th
                                scope="col"
                                style="cursor: pointer; position: relative"
                                @click="mostrarEdit(index)"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="7"
                                    viewBox="0 0 27 8"
                                    fill="none"
                                >
                                    <path
                                        d="M19.5 4C19.5 5.933 21.067 7.5 23 7.5C24.933 7.5 26.5 5.933 26.5 4C26.5 2.067 24.933 0.5 23 0.5C21.067 0.5 19.5 2.067 19.5 4Z"
                                        fill="#99ABB4"
                                    />
                                    <path
                                        d="M10.1667 4C10.1667 5.933 11.7338 7.5 13.6667 7.5C15.5997 7.5 17.1667 5.933 17.1667 4C17.1667 2.067 15.5997 0.5 13.6667 0.5C11.7338 0.5 10.1667 2.067 10.1667 4Z"
                                        fill="#99ABB4"
                                    />
                                    <path
                                        d="M0.5 4C0.5 5.933 2.067 7.5 4 7.5C5.933 7.5 7.5 5.933 7.5 4C7.5 2.067 5.933 0.5 4 0.5C2.067 0.5 0.5 2.067 0.5 4Z"
                                        fill="#99ABB4"
                                    />
                                </svg>
                                <div v-if="item.edit" class="editar-box">
                                    <ul>
                                        <li @click="modalEdit(index, item)">
                                            Asignar grupos
                                        </li>
                                    </ul>
                                </div>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="button-guardar">
                <button @click="uploadFiles" class="btn btn-melon">
                    Guardar
                </button>
            </div>
            <!--end: Drag and Drop-->

            <!--Modal Grupo-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalEdit">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p class="modal-title" id="exampleModalLabel">
                                    Asignar grupo
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalEdit = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <label class="title-body" for="grupo"
                                    >Elegir el grupo:</label
                                ><br />
                                <select
                                    class="form-select"
                                    id="grupo"
                                    v-model="selectedGroup"
                                >
                                    <option
                                        v-for="group in groups"
                                        :key="group.Id"
                                        :value="group.Id"
                                    >
                                        {{ group.Nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-melon"
                                    @click="asignarGrupo()"
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <!--Modal Exito-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalExito">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p class="modal-title" id="exampleModalLabel">
                                    Carga de documentos
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalExito = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>Los archivos se cargaron correctamente.</p>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-guardar"
                                    @click="showModalExito = false"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <!--Modal Error-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalError">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p
                                    class="modal-title header-error"
                                    id="exampleModalLabel"
                                >
                                    ERROR
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalError = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>Error al cargar los archivos.</p>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-error"
                                    @click="showModalError = false"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <!--Modal Error Carga-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalError">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p
                                    class="modal-title header-error"
                                    id="exampleModalLabel"
                                >
                                    ERROR
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalError = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p
                                    v-for="(item, index) in mensajesError"
                                    :key="index"
                                >
                                    {{ item }}
                                </p>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-error"
                                    @click="showModalError = false"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!--end::Card body-->
        <Loading v-if="loading"></Loading>
    </div>
    <!--end::Card-->
</template>

<script>
import { Actions } from "@/store/enums/StoreEnums";
import DropZone from "@/components/dropZone/DropZone.vue";
import { ref } from "vue";
import { useStore } from "vuex";
import Loading from "@/components/Loading.vue";

export default {
    name: "Documents",
    components: {
        DropZone,
        Loading,
    },
    data() {
        const fechaActual = new Date();
        const dia = fechaActual.getDate();
        const mes = fechaActual.getMonth() + 1;
        const año = fechaActual.getFullYear();
        const store = useStore();

        return {
            selectAll: false,
            items: [],
            fecha: `${dia}/${mes}/${año}`,
            showModalEdit: false,
            showModalExito: false,
            showModalError: false,
            indexEdit: 0,
            selectedGroup: null,
            store,
            loading: false,
            peso: 0,
            mensajesError: [],
        };
    },
    watch: {
        selectAll: function (value) {
            this.items.forEach((item) => {
                item.selected = value;
            });
        },
    },
    methods: {
        modalEdit(index) {
            this.showModalEdit = true;
            this.indexEdit = index;
            this.selectedGroup = this.items[index].grupoId;
        },
        agregar(files) {
            var pesoParcial = this.peso;
            this.mensajesError = [];
            for (var i = 0; i < files.length; i++) {
                var error = false;
                pesoParcial += files[i].size;
                if (pesoParcial / 1024 / 1024 <= 5) {
                    this.peso = pesoParcial;
                    this.items.push({
                        nombreArchivo: files[i].name,
                        date: this.fecha,
                        group: "Todos",
                        grupoId: "00000000-0000-0000-0000-000000000001",
                        selected: false,
                        edit: false,
                        data: files[i],
                    });
                    error |= false;
                } else {
                    error |= true;
                    this.mensajesError.push(
                        `El archivo con nombre ${files[i].name} supera el límite de carga.`
                    );
                }

                if (error) {
                    this.showModalError = true;
                }
            }
        },
        async eliminarFilas() {
            this.loading = true;
            const promesas = [];
            this.items.forEach((item) => {
                if (!item.selected) {
                    const operacionAsincronica = new Promise((resolve) => {
                        setTimeout(() => {
                            this.peso -= item.data.size;
                            resolve();
                        }, 2000);
                    });

                    promesas.push(operacionAsincronica);
                }
            });
            await Promise.all(promesas);
            this.items = this.items.filter((item) => !item.selected);
            this.peso = this.selectAll ? 0 : this.peso;
            this.selectAll = this.selectAll ? false : true;
            this.loading = false;
        },
        mostrarEdit(index) {
            if (!this.items[index].edit) {
                this.items.forEach((item) => {
                    item.edit = false;
                });
            }
            this.items[index].edit = !this.items[index].edit;
        },
        async uploadFiles() {
            if (this.items.length > 0) {
                this.loading = true;
                const values = this.items.map((proxy) => {
                    return { ...proxy };
                });

                var formData = new FormData();
                values.forEach((value) => {
                    formData.append("documento", value.data);
                });

                formData.append("documentos", JSON.stringify(values));

                try {
                    const data = await this.store.dispatch(
                        Actions.UPLOAD_FILE,
                        formData
                    );
                    if (data.statusCode == 202) {
                        this.showModalExito = true;
                        this.items = [];
                        this.loading = false;
                    }
                } catch (error) {
                    console.log(error);
                    this.loading = false;
                    this.showModalError = true;
                }
            }
        },
        asignarGrupo() {
            this.items[this.indexEdit].grupoId = this.selectedGroup;
            for (var i = 0; i < this.groups.length; i++) {
                if (this.groups[i].Id == this.selectedGroup) {
                    this.items[this.indexEdit].group = this.groups[i].Nombre;
                }
            }
            this.showModalEdit = false;
        },
    },
    setup() {
        const store = useStore();
        const groups = ref([]);

        const fetchGroups = async () => {
            try {
                const data = await store.dispatch(Actions.GET_GROUPS);
                groups.value = data;
            } catch (error) {
                console.error(error);
            }
        };

        fetchGroups();

        return {
            groups,
        };
    },
};
</script>

<style scoped>
.contenedor-table {
    overflow-x: auto;
    white-space: nowrap;
}

.header-error {
    color: #c63737 !important;
}

.modal-dialog {
    width: 35rem;
}

.closeModel {
    border: 0px;
    background-color: #fff;
}

.title-body {
    color: #99abb4;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.selectGroup {
    border-radius: 50px;
    border: 1px solid #cecece;
    background: #fff;
    width: 100%;
    height: 35px;
}

.btn-guardar {
    display: flex;
    width: 120px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.btn-error {
    display: flex;
    width: 120px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #c63737;
    background: #c63737;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.modal-footer {
    padding: 0px 1.5rem 1.5rem 0px !important;
    border: 0px !important;
}

.card-body {
    padding: 0px;
}

#button-eliminar {
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
    padding-top: 20px;
    display: inline-flex;
    justify-content: end;
    width: 100%;
}

#button-guardar {
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
    padding-top: 38px;
    display: inline-flex;
    justify-content: end;
    width: 100%;
}

#button-eliminar button,
#button-guardar button {
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    display: flex;
    width: 120px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    color: #fff;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.table {
    margin-top: 22px;
    width: 100%;
    flex-shrink: 0;
    border-radius: 10px 10px 10px 10px;
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.thead-document {
    border-radius: 10px 10px 0px 0px;
    width: 100%;
    height: 40px;
    flex-shrink: 0;
}

.thead-document th {
    background: #006c90;
    color: #fff;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.th-1 {
    border-radius: 10px 0px 0px 0px;
    display: flex;
    justify-content: center;
    min-width: 4rem;
}

.th-2 {
    min-width: 33rem;
}

.th-3 {
    min-width: 14.3rem;
}

.th-4 {
    min-width: 8.75rem;
}

.th-5 {
    border-radius: 0px 10px 0px 0px;
    min-width: 3.125rem;
}

.card {
    background-color: rgba(243, 245, 246, 1);
}
.mr-2 {
    margin-right: 0.5rem !important;
}
.flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
}
.justify-content-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
}
.customer-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;
}
.customer-badge.status-true {
    background-color: #c8e6c9;
    color: #256029;
}
.customer-badge.status-1 {
    background-color: #ffd8b2;
    color: #805b36;
}
.customer-badge.status-false {
    background-color: #ffcdd2;
    color: #c63737;
}

/* tbody tr th {
    color: #99abb4 !important;
    font-size: 0.88rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
} */

.button-edit {
    width: 100%;
    height: 30px;
    flex-shrink: 0;
    border-radius: 10px;
    background: #fff;
    border-color: rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    color: #99abb4;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
}

.button-edit:hover {
    background: #006c90;
    color: white;
}

.selectGroup option {
    color: #99abb4;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 12px 15px 0px;
    height: 25px;
}
</style>
